export default __webpack_public_path__ + "eff039d20a14e2bb563968d369961f83.png";